import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown-box" }
const _hoisted_2 = { class: "dropdown-box__label" }

import { ProjectType } from '@/api-client/models/project/Contracts'
import DropdownStandard, { optionType } from '@/design-system/molecules/DropdownStandard.vue'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  projectTypes: { id: string; title: string }[]
  type: 'type' | 'status'
  selectedProjectTypes: string[]
  presentAsMultiSelect?: boolean
  optionsWithData?: Set<string | null>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardDropdownFilterProjectType',
  props: {
    projectTypes: {},
    type: {},
    selectedProjectTypes: {},
    presentAsMultiSelect: { type: Boolean, default: true },
    optionsWithData: { default: undefined }
  },
  emits: ["selectionChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { projectTypes, selectedProjectTypes } = toRefs(props)
const emits = __emit
const { t } = useI18n()

const multiSelect = computed<boolean>(() => {
  if (props.presentAsMultiSelect) {
    return true
  } else return true
})

const label = computed<string>(() => {
  if (multiSelect.value) {
    return t(`general__data__project-${props.type}(s)`)
  }
  return t(`general__data__project-${props.type}`)
})

const searchType = computed<string>(() => {
  return t(`general__data__project-${props.type}`).toLowerCase()
})

const title = computed<string>(() => {
  const enabledOptions = options.value.filter((x) => !x.disabled)
  const selectedOptionCount = enabledOptions.filter((x) => x.selected).length
  if (allSelected.value && !disabled.value) {
    return t(`general__text__all-project-${props.type}(s)`)
  }
  if (selectedOptionCount > 1) {
    return [
      selectedOptionCount,
      t('general__text__chosen').toLowerCase(),
      t(`general__data__project-${props.type}(s)`).toLowerCase()
    ].join(' ')
  }
  if (selectedOptionCount === 1) {
    const selection = options.value.find((x) => x.selected)
    return selection?.name ?? ''
  }
  if (!disabled.value && selectedOptionCount === 0) {
    if (multiSelect.value) {
      return (
        t('general__text__select') +
        ' ' +
        t(`general__data__project-${props.type}(s)`).toLowerCase()
      )
    }
    return (
      t('general__text__select') + ' ' + t(`general__data__project-${props.type}`).toLowerCase()
    )
  }
  return ''
})

const allSelected = computed<boolean>(() => {
  const allButFirst = options.value.slice(1)
  const enabledCount = allButFirst.filter((x) => !x.disabled).length
  const selectedCount = allButFirst.filter((x) => x.selected).length
  return enabledCount === selectedCount
})

const disabled = computed<boolean>(() => {
  if (options.value.length === 0) {
    return true
  }
  if (options.value.every((entry) => entry.disabled)) {
    return true
  }
  return false
})

const options = computed<optionType[]>(() => {
  const options: optionType[] = []
  for (const project of projectTypes.value) {
    options.push({
      id: project.id,
      name: project.title,
      value: undefined,
      disabled: shouldBeDisabled(project),
      selected: selectedProjectTypes.value.includes(project.id)
    })
  }
  options.sort(sortOption)
  return options
})

function select(project: string) {
  const index = selectedProjectTypes.value.findIndex((x) => x === project)
  if (index === -1 && project) {
    emits('selectionChanged', [...selectedProjectTypes.value, project as ProjectType])
  } else {
    const copy = [...selectedProjectTypes.value]
    copy.splice(index, 1)
    emits('selectionChanged', copy)
  }
}
function selectAll() {
  if (!allSelected.value) {
    const selection = projectTypes.value.map((x) => x.id)
    emits('selectionChanged', selection)
  } else {
    emits('selectionChanged', [])
  }
}

function shouldBeDisabled(projects: any): boolean {
  return !!props.optionsWithData && !props.optionsWithData.has(projects.id)
}
function sortOption(a: optionType, b: optionType) {
  if (a.disabled === b.disabled) {
    return a.name.localeCompare(b.name)
  }
  return a.disabled < b.disabled ? -1 : 1
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(label.value), 1),
    _createVNode(DropdownStandard, {
      options: options.value,
      searchType: searchType.value,
      title: title.value,
      multiSelect: multiSelect.value,
      isAllSelected: allSelected.value,
      hasSearch: true,
      disabled: disabled.value,
      onSelectAll: selectAll,
      onSelect: select
    }, null, 8, ["options", "searchType", "title", "multiSelect", "isAllSelected", "disabled"])
  ]))
}
}

})